import React, { Component } from "react";
import { injectIntl, intlShape } from "@ai360/core/intl";
import PropTypes from "prop-types";

import { DataTable } from "~/core";
import { withCrud } from "~/hocs";
import { FormattingHelpers } from "@ai360/core";
import { memoizeFormattedRecords } from "~/admin/utils";

import { service, actions } from "./log-data";
import { messages } from "../i18n-messages";

export class PicklistLog_ extends Component {
    static propTypes = {
        records: PropTypes.array,
        intl: intlShape.isRequired,
    };
    getFormattedRecords = memoizeFormattedRecords(FormattingHelpers.formatLogDetailText);
    render() {
        return (
            <div>
                <DataTable
                    service={service}
                    isCheckbox={false}
                    showFilterInput={false}
                    messages={messages}
                    {...this.props}
                    records={this.getFormattedRecords((this.props as any).records)}
                />
            </div>
        );
    }
}
export const PicklistLog = injectIntl(withCrud(PicklistLog_, service, actions));
